"use client";

"use client";

import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";

interface SuccessProps {
  onNextAction: () => void;
}

export default function Success({ onNextAction }: SuccessProps) {
  const t = useTranslations("auth");
  return (
    <div className="text-center space-y-6 pt-2">
      <h2 className="text-2xl font-bold tracking-tight text-foreground">Account created</h2>
      <p className="text-sm text-muted-foreground">Thanks for joining. Add your phone next so we can keep your account secure.</p>
      <Button onClick={onNextAction} className="w-full min-h-[48px] py-6 text-base rounded-full touch-manipulation" size="lg">
        Continue to phone verification
      </Button>
    </div>
  );
}
